import React from 'react'
import Accordion from 'react-bootstrap/Accordion'
import styled from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { ShowPageAccordionIcon } from '../ShowPageAccordions.styles'
import { ShowPageAccordionIconOld } from '../ShowPageAccordions.components'

export const SectionAccordionOld = styled(Accordion)`
  padding-bottom: 20px;
`

export const SectionAccordion = styled(Accordion)`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const SectionAccordionItem = styled(Accordion.Item)`
  border: none;
`

export const SectionAccordionHeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`

export const SectionAccordionHeader = styled(Accordion.Header).attrs(
  ({ $currentActiveKeys, $currentAccordionKey, children }) => {
    const isActive = $currentActiveKeys.includes($currentAccordionKey)
    return {
      forwardedAs: 'header',
      children: (
        <SectionAccordionHeaderContent>
          {children}
          <ShowPageAccordionIcon isActive={isActive} />
        </SectionAccordionHeaderContent>
      ),
    }
  },
)<{ $currentActiveKeys: string[]; $currentAccordionKey: string }>`
  .accordion-button {
    font-size: 20px;
    font-weight: 400;
    color: ${palette.neutral[900]};
    display: flex;
    gap: 12px;
    padding: 0px;
    border-bottom: 1px solid ${palette.neutral[100]};
    width: 100%;
    
    :focus,
    :hover,
    :not(.collapsed) {
      outline: none;
      background-color: unset;
      box-shadow: none;
    }
    
    ::after {
      display: none;
    }
    `

export const SectionAccordionHeaderOld = styled(Accordion.Header).attrs(
  ({ $currentActiveKeys, $currentAccordionKey, children }) => {
    const isActive = $currentActiveKeys.includes($currentAccordionKey)
    return {
      forwardedAs: 'header',
      children: (
        <>
          {children}
          <ShowPageAccordionIconOld isActive={isActive} />
        </>
      ),
    }
  },
)<{ $currentActiveKeys: string[]; $currentAccordionKey: string }>`
  .accordion-button {
    color: ${palette.blue[700]};
    font-size: 16px;
    font-weight: 500;
    display: flex;
    gap: 12px;
    padding: 16px 0 0;
    
    :focus,
    :hover,
    :not(.collapsed) {
      outline: none;
      background-color: unset;
      box-shadow: none;
    }
    
    ::after {
      display: none;
    }
    `

export const SectionAccordionBody = styled(Accordion.Body)`
  padding: 12px 0 0;
`

export const SectionAccordionBodyOld = styled(Accordion.Body)`
  padding: 0;
`
